import { render, staticRenderFns } from "./MyQuranProgramTeacher.vue?vue&type=template&id=5c7f8759&"
import script from "./MyQuranProgramTeacher.vue?vue&type=script&lang=js&"
export * from "./MyQuranProgramTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports